module.exports = __webpack_public_path__ + "img/twitter.b2cdc96d.svg";